import { Layout } from "src/components/Layout";

import { DetailsFinaMazeAccount } from "src/pages/LeanDeposit/Details/DetailsFinamazeAccount";

import {
  Banner,
  ReferenceNumber,
} from "src/pages/LeanDeposit/Details/cardSummaryInfo";

import { DivCom } from "src/pages/LeanDeposit/Details/styles/styleCardSummaryInfo";
import { Button, Deposit, FDeposit, Icon } from "src/components";
import ArrowCircleright from "src/assets/ArrowCircleright.svg";
import { useMediaQuery } from "src/hooks/useMediaQuery";
import { Wrapper } from "src/components/Wrapper/styled";
import styled from "styled-components";
import PageHeader from "src/components/PageHeader";
import { Button as UIButton } from "src/components/ui";
import { DialogFooter } from "src/components/ui/Modal";
import { ButtonContainer } from "src/pages/LeanDeposit/Details/styles/styleCardSummaryInfo";

const Page = styled.div`
  flex: 1;
  width: 100%;
  min-width: 0;
`;

export const DepositSummary = (props) => {
  const { client, formik, status, loading, asDialog } = props;
  const isMobile = useMediaQuery("(max-width: 576px)");

  const actions = (
    <>
      <UIButton variant="secondary" size="lg" onClick={props.onCancel}>
        Back
      </UIButton>
      <UIButton
        variant="primary"
        size="lg"
        type="submit"
        loading={loading}
        disabled={loading}
        onClick={() => {
          formik.handleSubmit();
        }}
      >
        Confirm deposit
      </UIButton>
    </>
  );

  const body = (
    <FDeposit leanWrapper={true} $full={asDialog} title="">
      <DivCom>
        <Banner
          amount={formik?.values?.amount}
          FinamazeAccount={formik?.values?.finamazeBankAccount}
          status={status}
        />
        <div className="test" style={{ marginTop: "16px" }}>
          <FDeposit.Title>Transfer Reference Number</FDeposit.Title>
          <FDeposit.SubText>
            Please open your personal bank account transfer page in another
            window to simultaneously perform the bank transfer to credit your
            account and get the Transfer Number or Reference Id.{" "}
          </FDeposit.SubText>
          <ReferenceNumber formik={formik} />
        </div>
        {/* Into the shell's real foot band, the way step one already does it.
            This used Deposit.Action with $band, which FAKES a band inside the
            body with `margin: 16px -20px -20px` — negative margins that only
            line up if the body's padding happens to be exactly 20px. Here it
            is not, so the band sat 21px from the left edge and 61px from the
            right, and the pair stacked full-width with the confirming action
            above the way back. Two steps of one dialog, two different
            footers. */}
        {asDialog ? (
          <DialogFooter>
            <ButtonContainer $band={false}>{actions}</ButtonContainer>
          </DialogFooter>
        ) : (
          <Deposit.Action>{actions}</Deposit.Action>
        )}
      </DivCom>
    </FDeposit>
  );

  if (asDialog) return body;

  return (
    <Page>
      <PageHeader
        name="Review your deposit"
        lead="Make the transfer from your own bank, then confirm it here with the reference your bank gives you."
        backLabel="Back to the amount"
        onBack={props.onCancel}
      />
      <Layout isMobile={isMobile}>
        <Wrapper>{body}</Wrapper>
      </Layout>
    </Page>
  );
};
